import { render, staticRenderFns } from "./AR-SL-Disclosure.vue?vue&type=template&id=dbf4a158&scoped=true&"
import script from "./AR-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./AR-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./AR-SL-Disclosure.vue?vue&type=style&index=0&id=dbf4a158&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf4a158",
  null
  
)

export default component.exports